module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-copy-e2b2014284bbc440d33be81d26998933.svg";